import styles from './style.module.css';
import bannerImage from './slider.jpg';
import { SearchFields } from '../../../components';
import React from 'react';
const index = () => {
  return (
    <div className={styles.container}>
      <img src={bannerImage} alt={'banner-background'} />
      {/*<div className={styles.captions}>*/}
      {/*  <h3>Your journey begins here with the best offers and prices</h3>*/}
      {/*  <h4>Enjoy, compore and Choose..</h4>*/}
      {/*</div>*/}
      <div className={styles.captions}>
        <SearchFields />
      </div>
    </div>
  );
};

export default index;
